<div (click)="selectProperty(property.title)" [ngStyle]="{'border-bottom-color': calcService.rm.propertyType == property.title ? 'white' : 'transparent' }" class="property" >
    <img [src]="property.image" width="50px" height="50px" style="padding:10px">
    <p class="title-5" [ngStyle]="{'font-weight': calcService.rm.propertyType == property.title ? '600' : '400' }">{{property.title}}</p>
</div>